/**
 * Converts a number to Indian Rupee format with commas and ₹ symbol.
 * Example: 1234567.89 => ₹ 12,34,567.89
 * @param {number|string} amount
 * @returns {string}
 */
export function toIndianRupeeFormat(amount) {
    if (amount === null || amount === undefined || isNaN(Number(amount))) {
        return "₹ 0";
    }
    const number = Number(amount);

    return (
        number.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    );

}
/**
 * Retrieves the client data from localStorage for use in all modules.
 * @returns {object|null} The client data object, or null if not found or invalid.
 */
export function getClientData() {
    try {
        const encodedData = localStorage.getItem('user_data');
        if (!encodedData) return null;
        const decodedData = atob(encodedData);
        const userData = JSON.parse(decodedData);
        if (userData && userData.client && Array.isArray(userData.client) && userData.client.length > 0) {
            return userData.client[0];
        }
        return null;
    } catch (error) {
        console.error("Error retrieving client data:", error);
        return null;
    }
}
// src/components/common.js or src/utils/common.js

export function getAvailableTabs() {

    const userData = getClientData();
    const setting = userData?.parent?.setting || {};
    const clientAccount = userData?.client_account || {};

     const tabs = [];

    if (clientAccount.is_equity_trading_active === "yes" || clientAccount.is_equity_index_trading_active === "yes") {
        tabs.push("NFO");
    }

    if (clientAccount.is_mcx_trading_active === "yes") tabs.push("MCX");
    if (clientAccount.is_cds_trading_active === "yes") tabs.push("CDS");
    if (clientAccount.is_crypto_trading_active === "yes") tabs.push("CRYPTO");
    if (clientAccount.is_forex_trading_active === "yes") tabs.push("FX");
    if (clientAccount.is_us_trading_active === "yes") tabs.push("US");

    return tabs;
}
